import service from "@/store/services/esigns-service";

export const state = () => ({
  list: {},
  esign: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, esign) => {
    state.esign = esign;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((esign) => {
      commit("SET_RESOURCE", esign);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((esign) => {
      commit("SET_RESOURCE", esign);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((esign) => {
      commit("SET_RESOURCE", esign);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  esign: (state) => state.esign,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((esign) => ({
      id: esign.id,
      name: `${esign.name}`,
    }));
  },
};

const esigns = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default esigns;
